const waitingOnSync = window.GLOBAL.WAITING_ON_SYNC;
const endpoint = window.GLOBAL.WAITING_ON_SYNC_ENDPOINT;
const timeoutDelay = 3000;

export default class AutoRefresh {
    constructor() {
        document.addEventListener('DOMContentLoaded', this._init.bind(this));
    }

    _checkRefresh() {
        this._request = this._request || new XMLHttpRequest();
        const request = this._request;
        request.open('GET', endpoint);
        request.setRequestHeader('Content-type', 'application/json; charset=utf-8');
        request.responseType = 'json';
        request.onload = () => {
            if (request.status === 200) {
                let result = request.response;
                if (typeof(request.response) === 'string') {
                    result = JSON.parse(result);
                }
                if (result.d === true) {  // sync completed, refresh page
                    window.location.reload();
                }
            } else { // endpoint failed, stop retry logic
                window.clearInterval(this._timeout);
            }
        };
        request.send();
    }



    _init() {
        if (waitingOnSync === true) {
            this._timeout = window.setInterval(this._checkRefresh, timeoutDelay);
        }
    }
}
